/* eslint-disable */
var currentProblemString = null;
var stepCount = 0;

function nextStep() {
    if (currentProblemString == null) {
        if (document.getElementById('input_field').value == '') return;
        currentProblemString = document.getElementById('input_field').value;
        currentProblemString = replaceAll(currentProblemString, ' ', '');
        currentProblemString = replaceAll(currentProblemString, 'x', '*');
        currentProblemString = replaceAll(currentProblemString, 'X', '*');
        currentProblemString = replaceAll(currentProblemString, '+-', '-');
        currentProblemString = replaceAll(currentProblemString, '-+', '-');
        currentProblemString = replaceAll(currentProblemString, '++', '+');
        currentProblemString = replaceAll(currentProblemString, '--', '+');
        currentProblemString = replaceAll(currentProblemString, '*+', '*');
        currentProblemString = replaceAll(currentProblemString, '/+', '/');
        currentProblemString = replaceAll(currentProblemString, ')(', ')*(');
        currentProblemString = replaceAll(currentProblemString, '()', '');
        currentProblemString = insertMultiplicationWhereNeeded(currentProblemString);
    }
    currentProblemString = replaceAll(currentProblemString, '-+', '-');
    currentProblemString = replaceAll(currentProblemString, '+-', '-');
    currentProblemString = replaceAll(currentProblemString, '--', '+');
    currentProblemString = replaceAll(currentProblemString, '++', '+');
    // check for invalid character [a-zA-Z]
    var pattern = /[a-zA-Z]/igm;
    var match;
    while (match=pattern.exec(currentProblemString)) {
        var msg = 'Invalid character at ' + match.index+1;
        var messageDiv = document.getElementById('messageDiv');
        messageDiv.innerHTML = msg;
        $(messageDiv).show();
        return;
    }
    var currentProblem = String(currentProblemString);
    if (currentProblem.indexOf('+') == 0) {
        currentProblem = currentProblem.substring(1);
    }
    var index = findNextOperation(currentProblem, 0);
    if (index != null && index.errorMessage != '') {
        messageDiv = document.getElementById('messageDiv');
        messageDiv.innerHTML = index.errorMessage;
        $(messageDiv).show();
        return;
    }
    else if (index == null) {
        document.getElementById('messageDiv').innerHTML = '';
        var table = document.getElementById('myTable');
        var row = table.insertRow(-1);
        row.insertCell(0);
        var cell2 = row.insertCell(1);
        var cell3 = row.insertCell(2);
        cell2.innerHTML = 'Answer';
        cell3.innerHTML = currentProblemString;
        document.getElementById('nextButton').disabled = true;
        return;
    }
    document.getElementById('messageDiv').innerHTML = '';

    var substring = currentProblem.substring(index.start,
            index.end+1);
    var ans;
    if (substring.indexOf('/') > -1) {
        ans = eval(substring);
        ans = ans.toFixed(2);
    }
    else if (substring.indexOf('^') > -1) {
        ans = new algebra.parse(substring);
    }
    else {
        ans = eval(substring);
    }
    var prob = '';
    var cell1Text = '';
    var cell2Text = '';
    if (index.start > 0) {
        var str = currentProblem.substring(0,
                  index.start);
        prob += new String(str);
        var str2 = new String(str);
        str2 = replaceAll(str2, '*', ' &#215 ');
        str2 = replaceAll(str2, '/', ' / ');
        str2 = replaceAll(str2, '+', ' + ');
        str2 = replaceAll(str2, '-', ' - ');
        cell1Text += new String(str2); // append beginning
        cell2Text += new String(str2); // append beginning
    }

    prob += ans;
    substring = replaceAll(substring, '*', ' &#215 ');
    substring = replaceAll(substring, '/', ' / ');
    substring = replaceAll(substring, '+', ' + ');
    substring = replaceAll(substring, '-', ' - ');
    cell1Text += '<span style="color: #4877c0">' + substring + '</span>';
    cell2Text += '<span style="color: #4877c0">' + ans + '</span>';

    if (index.end < currentProblem.length-1) {
        str = currentProblem.substring(index.end+1);
        prob += new String(str);
        str2 = new String(str);
        str2 = replaceAll(str2, '*', ' &#215 ');
        str2 = replaceAll(str2, '/', ' / ');
        str2 = replaceAll(str2, '+', ' + ');
        str2 = replaceAll(str2, '-', ' - ');
        cell1Text += new String(str2); // append end
        cell2Text += new String(str2); // append end
    }

    stepCount++;
    currentProblemString = prob;

    // Find a <table> element with id="myTable":
    table = document.getElementById('myTable').getElementsByTagName('tbody')[0];

    // Create an empty <tr> element and add it to the 1st position of the table:
    row = table.insertRow(-1);

    // Insert new cells (<td> elements) at the 1st and 2nd position of the "new" <tr> element:
    var cell1 = row.insertCell(0);
    cell2 = row.insertCell(1);
    cell3 = row.insertCell(2);

    cell1.className = 'text-center';

    // Add some text to the new cells:
    cell1.innerHTML = stepCount;
    cell2.innerHTML = cell1Text;
    cell3.innerHTML = cell2Text;
}
function escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
}
function insertMultiplicationWhereNeeded(str) {
  var returnStr = '';
  for(var i=0; i<str.length;i++) {
      if (str[i] === '(') {
        if (i > 0 && !isNaN(str[i-1])) {
                returnStr += '*';
                returnStr += str[i];
        }
        else {
               returnStr += str[i];
        }
      }
      else if (str[i] === ')') {
        if (i < str.length && !isNaN(str[i+1])) {
                returnStr += str[i];
                returnStr += '*';
        }
        else {
               returnStr += str[i];
        }
      }
      else {
          returnStr += str[i];
      }
  }
  return returnStr;
}
function replaceAll(str, find, replace) {
    return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}
function findNextOperation(problemString, index) {
    var count1 = (problemString.match(/\(/g) || []).length;
    var count2 = (problemString.match(/\)/g) || []).length;
    if (count1 > count2) {
        return OperationIndex(-1, -1, 'Missing a close parenthesis.');
    }
    else if (count2 > count1) {
        return OperationIndex(-1, -1, 'Too many close parenthesis.');
    }

    var openParenIndex = problemString.lastIndexOf('(');
    if (openParenIndex >= 0) {
        var closeParenIndex = problemString.indexOf(')', openParenIndex);
        if (closeParenIndex > 0) {
            var substring = problemString.substring(openParenIndex+1,
                                                       closeParenIndex);
            var operationIndex = findNextOperation(substring,
                                                   openParenIndex+index+1);
            if (operationIndex == null) {
              if (!isNaN(substring) && problemString.length > closeParenIndex
                && problemString.charAt(closeParenIndex+index+1) == '^') {
                var i=closeParenIndex+index+2;
                var found = false;
                while (found == false && i < problemString.length) {
                  if (!isNaN(problemString.charAt(i))) {
                    i++;
                  }
                  else {
                    found = true;
                  }
                }
                // capture the ^X outside the end parenthesis
                    operationIndex = OperationIndex(openParenIndex+index,
                            i-1,
                            '');
              }
              else {
                    operationIndex = OperationIndex(openParenIndex+index,
                                                    closeParenIndex+index,
                                                    '');
              }
            }
            return operationIndex;
        }
        else {
            return OperationIndex(-1, -1, 'Missing close parenthesis.');
        }
    }

    var powerIndex = problemString.indexOf('^');
    if (powerIndex > 0) {
        var startIndex = powerIndex-1;
        var endIndex = powerIndex+1;
        if (problemString.charAt(endIndex) == '-') {
            endIndex++;
        }
        operationIndex = findOperationIndex(problemString,
                                  index,
                                  startIndex,
                                  endIndex);
        return operationIndex;
    }

    var multiplicationIndex = problemString.indexOf('*');
    var divisionIndex = problemString.indexOf('/');
    startIndex = -1;
    endIndex = -1;
    if (multiplicationIndex > 0 &&
        (divisionIndex < 0 || multiplicationIndex < divisionIndex)) {
        startIndex = multiplicationIndex-1;
        endIndex = multiplicationIndex+1;
    }
    else if (divisionIndex > 0 &&
             (multiplicationIndex < 0 || divisionIndex < multiplicationIndex)) {
        startIndex = divisionIndex-1;
        endIndex = divisionIndex+1;
    }
    if (startIndex >= 0) {
        if (problemString.charAt(endIndex) == '-') {
            endIndex++;
        }
        return findOperationIndex(problemString,
                                  index,
                                  startIndex,
                                  endIndex);
    }

    var additionIndex = problemString.indexOf('+', 1);
    var subtractionIndex = problemString.indexOf('-', 1);
    if (additionIndex > 0 &&
        (subtractionIndex <= 0 || additionIndex < subtractionIndex)) {
        startIndex = additionIndex-1;
        endIndex = additionIndex+1;
    }
    else if (subtractionIndex > 0 &&
             (additionIndex <= 0 || subtractionIndex < additionIndex)) {
        startIndex = subtractionIndex-1;
        endIndex = subtractionIndex+1;
    }
    if (startIndex >= 0) {
        operationIndex = findOperationIndex(problemString,
                                  index,
                                  startIndex,
                                  endIndex);
        return operationIndex;
    }

    return null;
}

function findOperationIndex(problemString, index, startIndex, endIndex) {
    var count = startIndex;
    while(count >= 0) {
         if (!isNaN(problemString.charAt(count))) {
             count--;
         }
         else if (problemString.charAt(count) == '-' &&
                  (count==0 || (count-1 > 0 && isNaN(problemString.charAt(count-1))))) {
             count--;
         }
         else if (problemString.charAt(count) == '.') {
             count--;
         }
         else {
             break;
         }
    }
     startIndex = count;
     if (count >= 0 &&
         (isNaN(problemString.charAt(count)) ||
          problemString.charAt(count) != '-' ||
          problemString.charAt(count) != '.')) {
         startIndex = count+1;
     }
     if (startIndex < 0) startIndex = 0;
     count = endIndex;
     while (count < problemString.length-1 &&
            (!isNaN(problemString.charAt(count)) ||
    //          problemString.charAt(count) == '-' ||
             problemString.charAt(count) == '.')) {
         count++;
     }
     endIndex = count;
     if (isNaN(problemString.charAt(count))) {
         endIndex = count-1;
     }

     if (startIndex > 0 &&
         endIndex < problemString.length-1 &&
         problemString.charAt(startIndex-1) == '(' &&
         problemString.charAt(endIndex+1) == ')') {
       alert(problemString);
         return OperationIndex(startIndex-1+index, endIndex+1+index, '');
     }
     var operationIndex = OperationIndex(startIndex+index, endIndex+index, '');
     return operationIndex;
}

function OperationIndex (startIn, endIn, error) {
    var obj = {
            start:  startIn,
            end: endIn,
            errorMessage: error
          };
    return obj;
}

function clearData() {
    document.getElementById('nextButton').disabled = false;
    var table = document.getElementById('myTable');
    for(var i = table.rows.length - 1; i > 0; i--) {
        table. deleteRow(i);
    }
    document.getElementById('input_field').value = '';
    currentProblemString = null;
    stepCount = 0;
    var messageDiv = document.getElementById('messageDiv');
    messageDiv.innerHTML = '';
    $(messageDiv).hide();
    //document.getElementById("messageDiv").innerHTML = "";
}

function startOver() {
    document.getElementById('nextButton').disabled = false;
    var table = document.getElementById('myTable');
    for(var i = table.rows.length - 1; i > 0; i--) {
        table. deleteRow(i);
    }
    currentProblemString = null;
    stepCount = 0;
    var messageDiv = document.getElementById('messageDiv');
    messageDiv.innerHTML = '';
    $(messageDiv).hide();
    //document.getElementById("messageDiv").innerHTML = "";
}

$(document).ready(function(){
    $('#input_field').each(function() {
        var messageDiv = document.getElementById('messageDiv');
        $(messageDiv).hide();

       var elem = $(this);

       // Save current value of element
       elem.data('oldVal', elem.val());

       // Look for changes in the value
       elem.bind('propertychange change click keyup input paste', function(event){
          // If value has changed...
          if (elem.data('oldVal') != elem.val()) {
           // Updated stored value
           elem.data('oldVal', elem.val());

           // Do action
           startOver();
         }
       });
     });
});
window.nextStep = nextStep;
window.startOver = startOver;
window.clearData = clearData;



/** WEBPACK FOOTER **
 ** ./client/app/scripts/vendor/orderofoperations.src.js
 **/